module.exports = __webpack_public_path__ + "website/img/bg_pr.dd9ccc59.png";